import { render, staticRenderFns } from "./ColaA.vue?vue&type=template&id=644f98de&scoped=true"
import script from "./ColaA.vue?vue&type=script&lang=js"
export * from "./ColaA.vue?vue&type=script&lang=js"
import style0 from "./ColaA.vue?vue&type=style&index=0&id=644f98de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644f98de",
  null
  
)

export default component.exports